import { nextArrow, prevArrow } from "@/global/slick-options";

const testimonialSliders = document.querySelectorAll( '[data-slider="testimonials-slider"' );
if ( testimonialSliders.length ) {
    testimonialSliders.forEach( slider => {
        let parentEle = jQuery( slider.closest( '.testimonials' ) );
        if ( slider.dataset.sliderLayout == 'columns' ) {
            jQuery( slider ).slick( {
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '100px',
                arrows: true,
                nextArrow,
                prevArrow,
                rows: 0,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 1,
                            centerPadding: '200px',
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                            centerPadding: '100px',
                        }
                    },
                    {
                        breakpoint: 501,
                        settings: {
                            slidesToShow: 1,
                            centerPadding: '30px',
                        }
                    }
                ]
            } );
        } else {
            jQuery( slider ).slick( {
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                arrows: true,
                prevArrow,
                nextArrow,
            } );
        }
    } );
}
